/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmstools_View_Hint1Inputs */

const vi_cmstools_view_hint1 = /** @type {(inputs: Cmstools_View_Hint1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nội dung (HTML) của lần đăng này.`)
};

/**

* @param {Cmstools_View_Hint1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmstools_view_hint1 = /** @type {((inputs?: Cmstools_View_Hint1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmstools_View_Hint1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmstools_view_hint1(inputs)
});
export { cmstools_view_hint1 as "cmsTools_view_hint" }